export default "__VITE_PUBLIC_ASSET__a3336223__"